import{e as o,m as s}from"./chunk-HBP5N4FR.js";var d,I=o(()=>{s();d=(t=>(t.signature="signature",t.sessionId="sessionId",t.status="status",t.address="address",t))(d||{})});export{d as a,I as b};
//# sourceMappingURL=chunk-W6HPOJ7Z.js.map
